import { Phone } from "lucide-react";
import { BUSINESS } from "@/lib/business";
import { cn } from "@/lib/utils";

export function PhoneButton({
  variant = "primary",
  size = "md",
  className,
  label,
}: {
  variant?: "primary" | "ghost" | "secondary";
  size?: "sm" | "md" | "lg";
  className?: string;
  label?: string;
}) {
  const sizes = {
    sm: "text-sm px-3 py-2",
    md: "text-base px-5 py-3",
    lg: "text-lg md:text-xl px-7 py-4",
  };
  const variants = {
    primary:
      "bg-primary text-primary-foreground hover:bg-primary-dark shadow-lg shadow-primary/30",
    secondary:
      "bg-secondary text-secondary-foreground hover:opacity-90",
    ghost:
      "bg-transparent text-primary-foreground border border-primary-foreground/40 hover:bg-primary-foreground/10",
  };
  return (
    <a
      href={BUSINESS.phoneHref}
      onClick={() => {
        // @ts-expect-error optional analytics
        window.dataLayer?.push?.({ event: "phone_click" });
      }}
      className={cn(
        "inline-flex items-center gap-2 rounded-md font-extrabold tracking-tight transition-colors",
        sizes[size],
        variants[variant],
        className,
      )}
    >
      <Phone className="h-5 w-5" aria-hidden />
      <span>{label ?? `Call ${BUSINESS.phone}`}</span>
    </a>
  );
}